// extracted by mini-css-extract-plugin
export default {"sideBtn":"sidebar_sideBtn__prbYp","popup":"sidebar_popup__oiiIM","arrowTop":"sidebar_arrowTop__sGWRJ","popupWrapper":"sidebar_popupWrapper__hoDap"};